var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"o-btn",class:[
    { 'o-btn--icon-r': _vm.iconPosition === 'right' },
    { 'o-btn--icon-l': _vm.iconPosition === 'left' }
  ],attrs:{"type":_vm.type}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.icon && _vm.icon!= 'preloader')?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),(_vm.icon && _vm.icon== 'preloader')?_c('o-preloader',{attrs:{"color":"white"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }